<template lang="html">
<div>
    <div id="map"></div>

    <input type="hidden" :value="map" />
    <input type="hidden" :value="assetManager" />
    <input type="hidden" :value="assetsLayer" />
    <input type="hidden" :value="dlsLayer" />
    <input type="hidden" :value="pipelineLayer" />
    <input type="hidden" :value="gridLayer" />
    <input type="hidden" :value="townshipHighlightLayer" />
</div>

</template>

<script>
import L from 'leaflet'
import Esri from 'esri-leaflet'
import MarkerCluster from 'leaflet.markercluster'
import axios from 'axios'
import {
  mapActions
} from 'vuex'

import {
  config
} from '../config'

const mapMaxZoom = 20
const mapDetectRetina = true
const mapCenter = [55, -114]
const mapInitialZoom = 6
const mapZoomControl = false

const tileFormat = "image/png"
const tileTransparent = true
const tileTiled = true
const tileOpacity = 0.5


let gridLayer = null;

const cartoLight = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
  maxZoom: mapMaxZoom,
  detectRetina: mapDetectRetina,
  attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attribution">CARTO</a>'
})

const pipelineLayer = L.tileLayer(config.pipelineLayerUrl, {
  tiled: tileTiled,
  opacity: tileOpacity,
  transparent: tileTransparent
})

const provinceLayer = L.tileLayer(config.provinceLayerUrl, {
  tiled: tileTiled,
  opacity: tileOpacity,
  transparent: tileTransparent
})

const dlsGridLayer = Esri.dynamicMapLayer({
  url: 'https://mapping.geologic.com/arcgis/rest/services/EE_PROD/EE_CanadaGrids/MapServer',
  proxy: 'https://secure.junewarren-nickles.com/arcgis/proxy.ashx',
  opacity: 1
})

const logo = L.control({
  position: 'bottomleft'
})

logo.onAdd = map => {
  let div = L.DomUtil.create('div', 'logo')
  let logo = require('../assets/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png')
  div.innerHTML = `<a href="https://www.dobenergy.com/" target="_blank"><img class="logo" src="${logo}" /></a>`
  return div
}

export default {
  data() {
    return {}
  },
  methods: {
    ...mapActions([
      'loadAssetsLayer',
      'updateTownshipHighlightLayer'
    ])
  },
  computed: {
    map() {
      return this.$store.state.map
    },
    assetManager() {
      return this.$store.state.assetManager
    },
    assetsLayer() {
      return this.$store.state.assetsLayer
    },
    dlsLayer() {
      return this.$store.state.dlsLayer
    },
    pipelineLayer() {
      return this.$store.state.pipelineLayer
    },
    gridLayer() {
      return this.$store.state.gridLayer
    },
    townshipHighlightLayer() {
      return this.$store.state.townshipHighlightLayer
    }
  },

  mounted() {
    let map = L.map("map", {
      center: mapCenter,
      zoom: mapInitialZoom,
      zoomControl: mapZoomControl
    })

    L.control.zoom({
      position: 'bottomright'
    }).addTo(map)

    this.$store.commit('updateMap', map)

    cartoLight.addTo(map)

    logo.addTo(map)

    provinceLayer.addTo(map)

    this.loadAssetsLayer(null)

    map.attributionControl.addAttribution('Asset data &copy; <a href="http://www.canoils.com/" target="_blank">CanOils</a>')

  },
  updated() {

    this.$nextTick(() => {

      if (this.assetManager) {
        this.map !== null && this.assetsLayer !== null && this.map.addLayer(this.assetsLayer)
      } else {
        this.map.removeLayer(this.assetsLayer)
      }

      // Draw townhship highlights
      if (this.townshipHighlightLayer !== null) {
        this.map.addLayer(this.townshipHighlightLayer)
        this.map.fitBounds(this.townshipHighlightLayer.getBounds())
      }

      //   Draw DLS search results
      if (this.dlsLayer !== null) {
        this.map.hasLayer(this.dlsLayer) && this.map.removeLayer(this.dlsLayer)
        let _dlsLayer = L.geoJSON(this.dlsLayer, {
          style: {
            fillOpacity: 0.5,
            fillColor: '#bdbdbd',
            color: '#bdbdbd',
            weight: 1
          }
        })

        this.map.addLayer(_dlsLayer)
        this.map.fitBounds(_dlsLayer.getBounds())

        setTimeout(() => {
          this.map.removeLayer(_dlsLayer)
          this.$store.commit('updateDlsLayer', null)
        }, 2000)

      }

      if (this.pipelineLayer) {
        pipelineLayer.addTo(this.map)
      } else {
        this.map.removeLayer(pipelineLayer)
      }

      if (this.gridLayer) {
        dlsGridLayer !== null && dlsGridLayer.addTo(this.map)
      } else {
        this.map.removeLayer(dlsGridLayer)
      }

    })

  }
}
</script>

<style lang="css">

@import "../../node_modules/leaflet/dist/leaflet.css";

#map {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 0;
}

.marker-cluster {
    background-clip: padding-box;
    border-radius: 20px;
    /*background-color: rgba(221,28,119, 0.3);*/
}

.marker-cluster div {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    margin-top: 5px;
    text-align: center;
    border-radius: 15px;
    font: 14px "Helvetica Neue", Arial, Helvetica, sans-serif;
    font-weight: bold;
    color: #fff;

    /*IE11 workaround*/
    display: flex;
    align-items: center;
    justify-content: center;
}

.marker-cluster div>span {
    vertical-align: -webkit-baseline-middle;
    vertical-align: -webkit-baseline-middle;
}

.royalty {
    background-color: rgba(0, 133, 177, 0.3);
}

.royalty div {
    background-color: rgba(0, 133, 177, 0.6);
}

.land {
    background-color: rgba(133, 168, 0, 0.3);
}

.land div {
    background-color: rgba(133, 168, 0, 0.6);
}

.production {
    background-color: rgba(239, 85, 52, 0.3);
}

.production div {
    background-color: rgba(239, 85, 52, 0.6);
}

.app-popup {
    max-height: 200px;
    overflow-y: auto;
}

.logo {
    height: 50px;
}

.leaflet-left .leaflet-control {
  margin-left: 15px !important;
  margin-bottom: 15px !important;
}

@media screen and (max-width: 600px) {
    .logo {
        height: 40px;
        width: auto !important;
    }
    .leaflet-left .leaflet-control {
        margin-left: 15px !important;
        margin-bottom: 25px !important;
    }
}
</style>



// WEBPACK FOOTER //
// Map.vue?6d151986